export const LoginTranslation = {
  guarderia: {
    token: 'Login.guarderia.token.fail',
  },
  register: {
    heading: 'register.stepper.heading',
    step1: 'register.stepper.step1',
    step2: 'register.stepper.step2',
    step3: 'register.stepper.step3',
    basicForm: {
      title: 'register.stepper.step2.form.title',
      errorBefore: 'register.stepper.step2.form.errorBefore',
      errorBold: 'register.stepper.step2.form.errorBold',
      errorMail: 'register.stepper.step2.form.email',
      modalTitle: 'register.stepper.step2.form.modal.title',
      modalDescription: 'register.stepper.step2.form.modal.description',
      errorAfter: 'register.stepper.step2.form.errorAfter',
      modalOk: 'register.stepper.step2.form.modal.ok',
      Ok: 'register.stepper.step2.form.ok',
      success: 'register.stepper.step2.form.success',
    },
    otpForm: {
      title: 'register.stepper.step3.title',
      toast: 'register.stepper.step3.toast',
    },
    errorPage: {
      title: 'register.stepper.step2.errorPage.title',
      SelfAccountCreationText: 'register.stepper.step2.errorPage.SelfAccountCreationText',
      ManagerWithRoleAccountCreation:
        'register.stepper.step2.errorPage.ManagerWithRoleAccountCreation',
      default_1: 'register.stepper.step2.errorPage.default_1',
      default_2: 'register.stepper.step2.errorPage.default_2',
      ServerError: 'register.stepper.step2.errorPage.ServerError',
      ServerError2: 'register.stepper.step2.errorPage.ServerError2',
      button: 'register.stepper.step2.errorPage.button',
    },
    identifyForm: {
      subtitle: 'register.stepper.step1.subtitle',
    },
    registerForm: {
      name: 'register.stepper.step2.name',
      surname: 'register.stepper.step2.surname',
      surname2: 'register.stepper.step2.surname2',
      email: 'register.stepper.step2.email',
      username: 'register.stepper.step2.userName',
      userNameLegend: 'register.stepper.step2.userNameLegend',
      userNameError: 'register.stepper.step2.form.userNameError',
    },
    emailSent: {
      subtitle: 'register.emailSent.subtitle',
    },
  },
  form: {
    pageTitle: 'Login.form.pageTitle',
    data: {
      user: {
        label: 'Login.form.data.user.label',
        placeholder: 'Login.form.data.user.placeholder',
        legend: 'Login.form.data.user.legend',
      },
      password: {
        label: 'Login.form.data.password.label',
        placeholder: 'Login.form.data.password.placeholder',
      },
    },
    rememberUser: 'Login.form.rememberUser',
    forgotPass: 'Login.form.forgotPass',
    createAccount: 'Login.form.createAccount',
    createAccountLink: 'Login.form.createAccountLink',
    submitBtn: 'Login.form.submitBtn',
    errors: {
      username: {
        aboveMaxLength: 'Login.form.errors.username.aboveMaxLength',
        belowMinLength: 'Login.form.errors.username.belowMinLength',
      },
      global: {
        incorrectUserOrPass: 'Login.form.errors.global.incorrectUserOrPass',
      },
    },
  },
  recovery: {
    pageTitle: 'Login.recovery.pageTitle',
    form: {
      title: 'Login.recovery.form.title',
      subtitle: 'Login.recovery.form.subtitle',
      resetPassword: {
        title: 'Login.recovery.form.resetPassword.title',
        usernameLabel: 'Login.recovery.form.resetPassword.usernameLabel',
        subtitle: 'Login.recovery.form.resetPassword.subtitle',
        resendMailToast: 'Login.recovery.form.resetPassword.resendMailToast',
      },
      passwordLabel: 'Login.recovery.form.passwordLabel',
      passwordLegend: 'Login.recovery.form.passwordLegend',
      repeatPasswordLabel: 'Login.recovery.form.repeatPasswordLabel',
    },
    errorModal: {
      alert: 'Login.recovery.errorModal.alert',
      subtitle: 'Login.recovery.errorModal.subtitle',
      button: 'Login.recovery.errorModal.button',
      mailtoSubject: 'Login.recovery.errorModal.mailtoSubject',
    },
    emailSent: {
      alert: 'Login.recovery.emailSent.alert',
      title: 'Login.recovery.emailSent.title',
      subtitle: 'Login.recovery.emailSent.subtitle',
      resendCode: 'Login.recovery.emailSent.resendCode',
      resendCodeLink: 'Login.recovery.emailSent.resendCodeLink',
    },
    expiredToken: {
      title: 'Login.recovery.expiredToken.title',
      subtitle: 'Login.recovery.expiredToken.subtitle',
    },
    passwordChangeSuccess: {
      subtitle: 'Login.recovery.passwordChangeSuccess.subtitle',
    },
    passwordChangeError: {
      subtitle: 'Login.recovery.passwordChangeError.subtitle',
      subtitle2: 'Login.recovery.passwordChangeError.subtitle2',
    },
  },
  navbar: {
    mailtoButton: {
      subject: 'Login.navbar.mailtoButton.subject',
    },
  },
  otp: {
    title: 'Login.otp.title',
    subtitle: 'Login.otp.subtitle',
    resendCode: 'Login.otp.resendCode',
    resendCodeLink: 'Login.otp.resendCodeLink',
    resendCodeToast: 'Login.otp.resendCodeToast',
    form: {
      codeLabel: 'Login.otp.form.codeLabel',
    },
  },
  terms: {
    pageTitle: 'terms.pageTitle',
    pageSubTitle: 'terms.pageSubTitle',
    form: {
      title: 'terms.form.title',
    },
  },
}
